/**
 * Card de Staff (design-system §7 · Card): superficie blanca sobre Crema, borde 1 px, radio lg,
 * padding 16 px, `shadow-1`. Título 18 px/600 sin encabezado decorado. La variante clicable eleva
 * a `shadow-2` en 120 ms. Nunca más de tres cards en el viewport inicial (§8.1).
 */
import { cn } from './cn';

import type { HTMLAttributes, ReactNode } from 'react';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
}

export function Card({ className, interactive, ...props }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-fm-lg border border-fm-border bg-fm-surface p-fm-4 shadow-fm-1',
        interactive &&
          'cursor-pointer transition-shadow duration-fm-fast ease-fm-standard hover:shadow-fm-2 active:shadow-fm-2 motion-reduce:transition-none',
        className,
      )}
      {...props}
    />
  );
}

export function CardTitle({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLHeadingElement> & { children: ReactNode }) {
  return (
    <h2 className={cn('font-display text-fm-lg font-semibold text-fm-text', className)} {...props}>
      {children}
    </h2>
  );
}

export function CardDescription({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('mt-fm-1 text-fm-base text-fm-text-secondary', className)} {...props} />;
}

export function CardContent({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('mt-fm-3 text-fm-base text-fm-text', className)} {...props} />;
}
